import { render, staticRenderFns } from "./SelectedPayment.vue?vue&type=template&id=cb6bf99e"
import script from "./SelectedPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedPayment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectedPayment.vue?vue&type=style&index=0&id=cb6bf99e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports